import { useTranslation } from 'react-i18next';
import Heading from 'components/Home/Heading';
import useExpanded from 'lib/hooks/useExpanded';
import { Link, Button } from 'components/Home/LinkGridShared';
import topModelsByYearCSS from '../styles/Home/TopModelsByYear';

const DEFAULT_NUM_OF_LISTINGS = 5;
const SEARCH_URLS = Object.freeze([
  { title: '2010 Chevy Camaro', url: '/chevrolet-camaro-2010' },
  { title: '2014 Chevy Camaro', url: '/chevrolet-camaro-2014' },
  { title: '2015 Chevy Camaro', url: '/chevrolet-camaro-2015' },
  { title: '2016 Chevy Camaro', url: '/chevrolet-camaro-2016' },
  { title: '2015 Dodge Charger', url: '/dodge-charger-2015' },
  { title: '2016 Ford Explorer', url: '/ford-explorer-2016' },
  { title: '2015 Ford F-150', url: '/ford-f+150-2015' },
  { title: '2013 Honda Accord', url: '/honda-accord-2013' },
  { title: '2014 Honda Accord', url: '/honda-accord-2014' },
  { title: '2015 Honda Accord', url: '/honda-accord-2015' },
  { title: '2016 Honda Accord', url: '/honda-accord-2016' },
  { title: '2015 Honda Civic', url: '/honda-civic-2015' },
  { title: '2016 Honda Civic', url: '/honda-civic-2016' },
  { title: '2016 Honda Pilot', url: '/honda-pilot-2016' },
  { title: '2015 Hyundai Sonata', url: '/hyundai-sonata-2015' },
  { title: '2019 Jeep Compass', url: '/jeep-compass-2019' },
  { title: '2015 Jeep Grand Cherokee', url: '/jeep-grand+cherokee-2015' },
  { title: '2015 Nissan Altima', url: '/nissan-altima-2015' },
  { title: '2013 Nissan Altima', url: '/nissan-altima-2013' },
  { title: '2016 Nissan Altima', url: '/nissan-altima-2016' },
  { title: '2016 Nissan Maxima', url: '/nissan-maxima-2016' },
  { title: '2015 Nissan Rogue', url: '/nissan-rogue-2015' },
  { title: '2015 Toyota Camry', url: '/toyota-camry-2015' },
  { title: '2016 Toyota Tacoma', url: '/toyota-tacoma-2016' },
]);

export default function TopModelsByYear() {
  const [expanded, topRef, toggleExpanded] = useExpanded();
  const { t } = useTranslation();

  const listSize = expanded ? SEARCH_URLS.length : DEFAULT_NUM_OF_LISTINGS;

  return (
    <div className="container" ref={topRef}>
      <Heading title={t('home.topModelsByYear.title')} />
      <div className="links" data-testid="links">
        {SEARCH_URLS.slice(0, listSize).map(({ title, url }) => (
          <Link key={url} url={url} section={'featured_mmy'}>
            {title}
          </Link>
        ))}
      </div>
      <Button
        expanded={expanded}
        onClick={toggleExpanded}
        section={'featured_mmy_show'}
      />
      <style jsx>{topModelsByYearCSS}</style>
    </div>
  );
}
